module.exports = __webpack_public_path__ + "static/media/voroni.37c11acd.jpg";